// extracted by mini-css-extract-plugin
module.exports = {"topBar":"styles_topBar__1-47f","topBarSpacer":"styles_topBarSpacer__2EM47","logoContainer":"styles_logoContainer__1nRKI","logo":"styles_logo__1XSaf","badge":"styles_badge__3CuGs"};